var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-base"},[_c('section',{ref:"tinymce",attrs:{"id":"editor"}},[_vm._v(" "+_vm._s(_vm.textInput)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }